import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import {
  loadRequest,
  loadSuccess,
  loadFailure,
  loadRequestUpdate,
  loadSuccessUpdate,
  loadFailureUpdate,
} from './actions';

export function* loadOcorrencia({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const res = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}detalhaOcorrencia&token=${state.auth.token}`,
      {
        protocolo: payload.protocolo,
      }
    );

    yield put(loadSuccess(res.data));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar os atendimentos, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}

export function* updateOcorrencia({ payload }: ReturnType<typeof loadRequestUpdate>): any {
  try {
    const state = yield select();
    const res = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}atualizaOcorrencia&token=${state.auth.token}`,
      {
        protocolo: payload.protocolo,
        status: payload.status,
        dtFinalizacao: payload.dtFinalizacao,
        codAtendente: payload.codAtendente,
        urgencia: payload.urgencia,
        justificativa: payload.justificativa,
      }
    );

    yield put(loadSuccessUpdate(res.data));
  } catch (error: any) {
    yield put(loadFailureUpdate());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao ao atualizar o atendimento, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
